import React from "react";
import PublicLegalTextPage from "./PublicLegalTextPage";

const AydinlatmaMetni = () => <PublicLegalTextPage field="kvkk" title="KVKK Aydınlatma Metni ve Açık Rıza Metni" />;

export default AydinlatmaMetni;
